import { useCallback, useEffect, useRef, useState } from 'react'

export const ANIMATE_MS = 700

export interface UseTypewriterResult {
  isAnimating: (id: string) => boolean
  start: (ids: string[]) => void
}

export function useTypewriter(): UseTypewriterResult {
  const [active, setActive] = useState<Set<string>>(() => new Set())
  const timer = useRef<ReturnType<typeof setTimeout> | null>(null)

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current)
    },
    [],
  )

  const start = useCallback((ids: string[]) => {
    if (ids.length === 0) return
    setActive(new Set(ids))
    if (timer.current) clearTimeout(timer.current)
    timer.current = setTimeout(() => setActive(new Set()), ANIMATE_MS)
  }, [])

  return {
    isAnimating: useCallback((id: string) => active.has(id), [active]),
    start,
  }
}
